var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTwitch = function SvgTwitch(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM9.083 6 7 8.143v7.714h2.5V18l2.083-2.143h1.667L17 12V6H9.083Zm7.084 5.571L14.5 13.286h-1.667l-1.458 1.5v-1.5H9.5V6.857h6.667v4.714Zm-1.25-3.214h-.834v2.572h.834V8.357Zm-3.125 0h.833v2.572h-.833V8.357Z",
    fill: "currentColor"
  })));
};
export default SvgTwitch;